import _defineProperty from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _FONT_SIZE, _LETTER_SPACING, _LINE_HEIGHT;
import PropTypes from 'prop-types';
export var SIZE = {
  XXS: 'xxSmall',
  XS: 'xSmall',
  S: 'small',
  M: 'medium',
  L: 'large'
};
export var SIZES = Object.values(SIZE);
export var FONT_SIZE = (_FONT_SIZE = {}, _defineProperty(_FONT_SIZE, SIZE.XXS, '12px'), _defineProperty(_FONT_SIZE, SIZE.XS, '14px'), _defineProperty(_FONT_SIZE, SIZE.S, '16px'), _defineProperty(_FONT_SIZE, SIZE.M, '20px'), _defineProperty(_FONT_SIZE, SIZE.L, '24px'), _FONT_SIZE);
export var LETTER_SPACING = (_LETTER_SPACING = {}, _defineProperty(_LETTER_SPACING, SIZE.XXS, 'normal'), _defineProperty(_LETTER_SPACING, SIZE.XS, 'normal'), _defineProperty(_LETTER_SPACING, SIZE.S, 'normal'), _defineProperty(_LETTER_SPACING, SIZE.M, '-0.01em'), _defineProperty(_LETTER_SPACING, SIZE.L, '-0.01em'), _LETTER_SPACING);
export var LINE_HEIGHT = (_LINE_HEIGHT = {}, _defineProperty(_LINE_HEIGHT, SIZE.XXS, '1.3'), _defineProperty(_LINE_HEIGHT, SIZE.XS, '1.3'), _defineProperty(_LINE_HEIGHT, SIZE.S, '1.4'), _defineProperty(_LINE_HEIGHT, SIZE.M, '1.2'), _defineProperty(_LINE_HEIGHT, SIZE.L, '1.2'), _LINE_HEIGHT);
export var propTypes = {
  children: PropTypes.node,
  element: PropTypes.oneOfType([PropTypes.oneOf(['p', 'span', 'a']), PropTypes.elementType]),
  size: PropTypes.oneOf(SIZES),
  extraSmallViewportsSize: PropTypes.oneOf(SIZES),
  smallViewportsSize: PropTypes.oneOf(SIZES),
  mediumViewportsSize: PropTypes.oneOf(SIZES),
  largeViewportsSize: PropTypes.oneOf(SIZES),
  extraLargeViewportsSize: PropTypes.oneOf(SIZES),
  emphasised: PropTypes.bool,
  underlined: PropTypes.bool
};
export var defaultProps = {
  element: 'p',
  size: SIZE.M,
  extraSmallViewportsSize: null,
  smallViewportsSize: null,
  mediumViewportsSize: null,
  largeViewportsSize: null,
  extraLargeViewportsSize: null,
  emphasised: false,
  underlined: false
};